module.exports = __webpack_public_path__ + "img/radar-chart-outlined.6b942ecb.svg";